// extracted by mini-css-extract-plugin
export default {"column":"render-table-cell_column__qhfZT","zero":"render-table-cell_zero__brR2E","placeHolderShimmer":"render-table-cell_placeHolderShimmer__fdvYL"};